import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Chip } from '@material-ui/core'

import {
  ERROR,
  NORMAL,
  ACCENT,
  DISTRESS,
  AVAILABLE,
  UNAVAILABLE,
} from 'app/constants/statusColors'

const StatusBadge = (props) => {
  const { type, label } = props

  const handleColor = () => {
    switch (type) {
      case UNAVAILABLE:
        return 'bg-neutrals-200 text-neutrals-400'
      case AVAILABLE:
        return 'text-primary bg-primary-200'
      case NORMAL:
        return 'text-green-600 bg-green-50'
      case DISTRESS:
        return 'text-orange-600 bg-orange-50'
      case ACCENT:
        return 'text-indigo-600 bg-indigo-100'
      case ERROR:
        return 'text-red-500 bg-red-50'
      default:
        return
    }
  }

  return (
    <Chip
      label={label}
      size="small"
      className={clsx('font-normal text-12', handleColor())}
      {...props}
    />
  )
}

StatusBadge.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
}

export default StatusBadge
